import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/main.css";

// 应用的唯一挂载入口。
// 这里故意保持很薄：全局状态、登录弹窗、下载逻辑都放在 App.tsx，
// 方便协作者从一个文件开始追踪前端业务流。
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
